// extracted by mini-css-extract-plugin
export default {"form":"AddFolder_form__Bp6fe","btnsContainer":"AddFolder_btnsContainer__+lEgq"};